

function LeadershipTier9DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                This talent is a massive power moment for any Leader.
                Much like many Tier 9 talents in this overhaul system, this is a completely
                game-changing effect when a player decides to use it.
                <br />
                Your entire team has free reign to move their entire movement speed to get into
                position before being granted Advantage on their next attack.
                <br />
                This is a clear tactical advantage, and power multiplier for your team that makes
                the player truly feel their impact on the field.
            </div>
            <p>
                <b className="AbilityHeaderSmall">WHY CAN THEY ONLY BENEFIT ONCE PER LONG REST?</b>
                <div className="animationFadeIn">
                    This effect is strong, and there's no denying that.
                    <br />
                    Allies can only be affected by it once per long rest (which coincides with the cooldown of this ability)
                    because if they could receive it multiple times then your party would stack multiple Leaders on one team which
                    reduces group variety and flexibility.
                    <br />
                    Additionally, effects such as the Initiative Aura given by the +1 skill
                    effect do not stack.
                    <br />
                    This is an example of designing so that players will not optimize their own fun out of the game.
                </div>
            </p>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                    As previously stated, this ability is game-warping in power and can turn the tide
                    in a way that accentuates a player's decision-making.
                    <br />
                    A Bishop's Opening is a chess opening that begins with
                    the moves 1. e4 e5, 2. Bc4.
                    It is so named because White's second move develops the bishop to the c4 square, where it puts
                    pressure on the f7 square and can help control the center of the board.
                    <p />
                    <b>Note:</b> This technique describes the movement of pieces from one location to another using a grid.
                    <br />
                    The grid is A through H on the X-Axis and 1 through 8 on the Y-Axis.
                </div>
            </p>
            <br />
        </div>
    )
}

export { LeadershipTier9DesignTemplate };